// 关于element-ui处理的方法
/**
 *
 * el-table-column formatter
 * @export
 * @param {*} row
 * @param {*} column
 * @param {*} cellValue
 * @param {*} index
 */
export function elFormatter (row, column, cellValue) {
  return (cellValue === 0 || cellValue) ? cellValue : '--'
}

/**
 *
 * el-table formatter 报警状态
 * @export
 * @param {*} row
 * @param {*} column
 * @param {*} cellValue
 * @return {*}
 */
export function alarmStatus (row, column, cellValue) {
  if (cellValue === '0') {
    return '未处理'
  } else if (cellValue === '1') {
    return '已处理'
  }
}
